<div class="tournment">
  <h2>  {{globalService?.customLang?.prizes}} </h2>
</div>
  <div class="Box">
  <div class="gifts">
    <img src="../../../../../assets/img/tecno-cup-iraq/First-winner.png" class="img-responsive ">
    <h4> 1200$ / 4 {{globalService?.customLang?.Phones}}</h4>
  </div>
  <div class="gifts">
    <img src="assets/img/tecno-cup-iraq/Second-winner.png" class="img-responsive ">
    <h4>800$ / 4 {{globalService?.customLang?.Phones}} </h4>
  </div>
    <div class="gifts">
    <img src="assets/img/tecno-cup-iraq/Third-winner.png" class="img-responsive ">
    <h4> 500$ / 4 {{globalService?.customLang?.Phones}} </h4>
  </div>

    <div class="gifts">
    <img src="assets/img/tecno-cup-iraq/Fourth-winner.png" class="img-responsive ">
    <h4> 500$</h4>
  </div>
</div>
    <div class="championship">
      <h2> {{globalService?.customLang?.tournament}} </h2>
    </div>

<div class="tournament-container">
  <ng-container *ngIf="tournaments && tournaments.length > 0; else nodata">

  <ng-container *ngFor="let tournament of tournaments" >
    <app-tournaments-reusable [tournament]="tournament" [backgroundImageBody]="'linear-gradient(255deg, rgba(203,48,102,1) 0%, rgba(203,48,102,1) 35%, rgba(22,191,253,1) 100%)'"
                              [colorBody]="'#ffffff'" [direction]="'ar'" [fillColor]="'#ffffff'">
    </app-tournaments-reusable>
  </ng-container>
  </ng-container>
  <ng-template #nodata>
    <div class="container">
      <div class=" no-data">
        <h2>{{globalService.customLang.no_tournaments_yet}}</h2>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>

